var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "560"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" 교육서비스 안내 ")]), _c('v-card-text', {
    staticClass: "text-center"
  }, [_vm._v(" 교육서비스는 YOUTUBE, VIMEO 영상 플랫폼과 연계하여 "), _c('br'), _vm._v(" 회원들의 교육 영상 시청 및 시청 여부 확인을 위한 기능입니다. "), _c('br'), _c('br'), _vm._v(" YOUTUBE, VIMEO의 별도 회원 가입 후 영상 등록 및 영상 스트리밍 기능 이용시 "), _c('br'), _vm._v(" 해당 사이트의 사용하는 영상의 링크를 입력하여 이용이 가능합니다. "), _c('br'), _c('br'), _vm._v(" 영상을 시청중인 회원과 채팅 서비스가 제공되며 "), _c('br'), _vm._v(" 영상을 시청한 회원의 시청 시간이 문서로 제공됩니다. "), _c('br')]), _c('v-btn', {
    staticClass: "mt-n8 mr-n4",
    attrs: {
      "absolute": "",
      "text": "",
      "icon": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }